import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="bg-img1 logn-bx">
      <div className="login-content">
        <img src="/ClientApp/build/Images/logo_FHD2_Hub.png" alt="" className="img-fluid" />
        <h3 style={{ marginTop: '1.5rem', marginBottom: '1rem' }}>Page Not Found</h3>
        <p style={{ marginBottom: '2.5rem', color: '#6c757d', fontSize: '0.95rem', lineHeight: '1.4' }}>
          The page you are looking for might have been removed or is temporarily unavailable.
        </p>
        
        <div style={{ marginTop: '1rem' }}>
          <button 
            onClick={handleGoHome} 
            style={{ 
              margin: '0 0.5rem', 
              padding: '0.75rem 1.5rem', 
              backgroundColor: '#007bff', 
              color: 'white', 
              border: 'none', 
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Go to Home
          </button>
          <button 
            onClick={handleGoBack} 
            style={{ 
              margin: '0 0.5rem', 
              padding: '0.75rem 1.5rem', 
              backgroundColor: '#6c757d', 
              color: 'white', 
              border: 'none', 
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;